export enum UserConsentEvent {
  NEEDS_POLICY_CONSENT_REQUESTED = 'UserConsentEvent:needs_policy_consent_requested'
}
